import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

const materialIconProps = {
  "aria-hidden": true,
  focusable: false,
  viewBox: "0 0 24 24",
} satisfies IconProps;

export function MoreVertOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2Z"
      />
    </svg>
  );
}

export function KeyboardArrowDownOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path fill="currentColor" d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41Z" />
    </svg>
  );
}

export function OpenInNewOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7ZM5 5h6V3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6h-2v6H5V5Z"
      />
    </svg>
  );
}

export function CloseOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M18.3 5.71 16.89 4.3 12 9.17 7.11 4.29 5.7 5.7 10.59 10.59 5.7 15.48 7.11 16.89 12 12l4.89 4.89 1.41-1.41-4.89-4.89 4.89-4.88Z"
      />
    </svg>
  );
}


export function SendOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M4.01 6.03 11.52 9.25 4 8.24l.01-2.21Zm7.5 8.72L4 17.97v-2.21l7.51-1.01ZM2.01 3 2 10l15 2-15 2 .01 7L23 12 2.01 3Z"
      />
    </svg>
  );
}

export function StopCircleOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12c0 5.52 4.48 10 10 10s10-4.48 10-10C22 6.48 17.52 2 12 2Zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm4-4H8V8h8v8Z"
      />
    </svg>
  );
}

export function ThumbUpOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M13.12 2.06 7.58 7.6C7.21 7.97 7 8.48 7 9v10c0 1.1.9 2 2 2h9c.8 0 1.52-.48 1.84-1.21l3.02-7.05c.09-.23.14-.47.14-.74v-1.91c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1l-1.05 1.06ZM5 21H1V9h4v12Zm4-2V8.98l4.34-4.34L12 11h9v1l-3 7H9Z"
      />
    </svg>
  );
}

export function ThumbUpFilledIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M1 21h4V9H1v12Zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2Z"
      />
    </svg>
  );
}

export function ThumbDownOutlinedIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M10.88 21.94 16.42 16.4c.37-.37.58-.88.58-1.41V5c0-1.1-.9-2-2-2H6c-.8 0-1.52.48-1.84 1.21l-3.02 7.05c-.09.23-.14.47-.14.74v1.91c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l1.05-1.06ZM19 3h4v12h-4V3Zm-4 2v10.02l-4.34 4.34L12 13H3v-1l3-7h9Z"
      />
    </svg>
  );
}

export function ThumbDownFilledIcon(props: IconProps) {
  return (
    <svg {...materialIconProps} {...props}>
      <path
        fill="currentColor"
        d="M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2Zm4 0v12h4V3h-4Z"
      />
    </svg>
  );
}

export function StreamingIndicatorIcon(props: IconProps) {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable={false} {...props}>
      <circle cx="6" cy="6" r="6" fill="var(--action-active, rgba(0, 24, 35, 0.56))" />
    </svg>
  );
}
